module.exports = __webpack_public_path__ + "img/arrow-down-to-dotted-line.68cc6cd2.svg";